<template>
	<div>
		<div class="mb-3">
			{{ item.value }}
		</div>
		<div class="small mb-1">
			Адрес: {{ item.data.address?.value }}
		</div>
		<div class="small mb-1">
			ИНН: {{ item.data.inn }}
		</div>
		<div class="small mb-1">
			ОГРН: {{ item.data.ogrn }}
		</div>
		<div v-if="item.data.management" class="small mb-1">
			Директор: {{ item.data.management?.name }}
		</div>
	</div>
</template>

<script>
export default {
	props: {
		item: { type: Object, required: true },
	},
};
</script>
